import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * ProUpgradeCard component displays a promotional section encouraging users to upgrade to Pro
 * This component should be shown at the bottom of each statistics tab when the user is not a pro member
 */
const ProUpgradeCard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleUpgradeClick = () => {
    navigate("/settings");
  };

  return (
    <div className="bg-gradient-to-r from-secondary/40 to-primary/40 backdrop-blur-sm rounded-lg p-6 shadow-lg border border-test/20 mt-4">
      <div className="flex flex-col md:flex-row items-center justify-between">
        <div className="mb-4 md:mb-0 md:mr-6">
          <h3 className="text-white text-lg font-semibold mb-2">
            {t("proUpgradeCard.title")}
          </h3>
          <p className="text-gray-300 text-sm mb-3">
            {t("proUpgradeCard.description")}
          </p>
          <ul className="text-gray-300 text-sm space-y-1 mb-4">
            <li className="flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 text-test mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
              {t("proUpgradeCard.features.deviationAnalysis")}
            </li>
            <li className="flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 text-test mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
              {t("proUpgradeCard.features.checkoutRoutes")}
            </li>
            <li className="flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 text-test mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
              {t("proUpgradeCard.features.performanceMetrics")}
            </li>
          </ul>
        </div>
        <div className="flex flex-col items-center">
          <button
            onClick={handleUpgradeClick}
            className="bg-test hover:bg-secondary text-primary px-6 py-3 rounded-full shadow-md transition duration-200 font-medium flex items-center"
          >
            <span>{t("proUpgradeCard.upgradeButton")}</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 ml-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          </button>
          <p className="text-gray-400 text-xs mt-2">
            {t("proUpgradeCard.unlockFeatures")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProUpgradeCard;
